import * as React from 'react';

import { createStructuredSelector, mconnect } from '../../state/redux';
import { IStyledComponent, styledComponent } from '../../theme';
import { IComponentStateProps, IConnectedComponentProps, IGraphHeaderStyles } from '../../types';
import { getHeaderClassNames, getHeaderStyles } from '../intentGraph.styles';
import {
  enableLinkClickLoggingSelector,
  globalVarsSelector,
  jsonPayloadMetaSelector,
  sessionIdSelector,
  topHeadingSelector
} from '../reducers/selectors.redux';

import { TextFieldComponent } from './textFieldComponent';

const uuidV4 = require('uuid/v4');
const mapStateToProps = createStructuredSelector({
  metadata: jsonPayloadMetaSelector,
  topHeading: topHeadingSelector,
  sessionId: sessionIdSelector,
  enableLinkClickLogging: enableLinkClickLoggingSelector,
  globalVars: globalVarsSelector
});

type IHeaderProps = ReturnType<typeof mapStateToProps> &
  IStyledComponent<IGraphHeaderStyles> &
  IConnectedComponentProps &
  IComponentStateProps;

class GraphHeaderC extends React.PureComponent<IHeaderProps> {
  public render(): React.ReactNode {
    const classNames = getHeaderClassNames(this.props.styles, {
      theme: this.props.theme,
      stylesFunc: this.props.stylesFunc
    });
    const key = this.props.metadata ? this.props.metadata.get('id') : uuidV4();
    return this.props.topHeading ? (
      <TextFieldComponent
        key={key}
        callbackHandlers={this.props.callbackHandlers}
        stylesFunc={this.props.stylesFunc}
        componentkey={`document$${this.props.metadata.get('id')}$topHeadingText`}
        className={classNames.headerRootDiv}
        textContent={this.props.topHeading}
        sessionId={this.props.sessionId}
        meta={this.props.metadata}
        logLinkClicks={this.props.enableLinkClickLogging}
        globalVars={this.props.globalVars}
        dialogId={this.props.dialogId}
      />
    ) : null;
  }
}

export const Header = mconnect(mapStateToProps, {})(styledComponent(GraphHeaderC, getHeaderStyles));
